import getStaticData from '../helpers/getStaticData'
import callAPI from '../helpers/callAPI'
import { REQUEST_CONTENT, receiveContent } from '../actions/content'

const content = store => next => action => {
  next(action)

  if (action.type !== REQUEST_CONTENT) {
    return
  }

  const dispatch = store.dispatch

  try {
    const contentApiConfig = getStaticData('sitecore')
    if (!contentApiConfig) {
      return
    }
    callAPI({
      url: `${contentApiConfig.url.replace(
        /{id}/i,
        contentApiConfig.groupofferid
      )}?language=${contentApiConfig.language}`,
    })
      .then(content => {
        dispatch(
          receiveContent({
            labels: content,
            status: 'success',
          })
        )
      })
      .catch(error => {
        throw new Error({ status: 'failure', error })
      })
  } catch (error) {
    dispatch(
      receiveContent({
        labels: [],
        status: error.status,
      })
    )
  }
}

export { content }
